import React, { useEffect, useState } from "react";
import { Card, Content, Description, Feature, Features, Footer, Image, LinkButton, Title, Video } from "./styles";
import { ArrowRight } from "lucide-react";

const ProjectCard = ({ video, image, title, description, features, link }) => {
    const [videoSrc, setVideoSrc] = useState(video.desktop);

    useEffect(() => {
        const updateVideo = () => {
            if(window.innerWidth <= 480) {
                setVideoSrc(video.mobile);
            } else if (window.innerWidth <= 1024) {
                setVideoSrc(video.tablet);
            } else {
                setVideoSrc(video.desktop);
            }
        };

        updateVideo();

        window.addEventListener("resize", updateVideo);

        return () => window.removeEventListener("resize", updateVideo);
    }, [video]);

    return (
        <Card>
            {video ? (
                <Video
                    key={videoSrc}
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    <source 
                        src={videoSrc}
                        type="video/mp4"
                    />
                </Video>
            ) : (
                <Image 
                    src={image}
                    alt={title}
                />
            )}

            <Content>
                <Title>{title}</Title>

                <Description>{description}</Description>

                <Features>
                    {features.map((feature) => (
                        <Feature key={feature}>
                            {feature}
                        </Feature>
                    ))}
                </Features>

                <Footer>
                    <LinkButton
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Ver proyecto
                        <ArrowRight size={20}/>
                    </LinkButton>
                </Footer>
            </Content>
        </Card>
    )
};

export default ProjectCard;